import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import getFormattedDate from "../../util/getFormattedDate";
import SearchIcon from "@mui/icons-material/Search";
import { BrowserRouter as Router, Link, useRouteMatch } from "react-router-dom";
import { Paper, TextField, InputAdornment } from "@mui/material";
import "./ProfileTable.css";

export default function ProfileTable({ rows, profile }) {
  let match = useRouteMatch();
  const [searchText, setSearchText] = useState("");
  const formatProfileName = (name) => {
    return name.replace("&", "%26");
  };
  return (
    <TableContainer sx={{ height: "60vh", padding: "15px" }} component={Paper}>
      <div className="profile-search">
        <TextField
          id="input-with-icon-textfield"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          variant="standard"
        />
      </div>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#3275a8" }}>
            <TableCell
              align="center"
              sx={{
                border: "1px solid black",
                fontWeight: "bold",
                fontSize: "20px",
                color: "white",
              }}
            >
              Profile Name
            </TableCell>
            <TableCell
              align="center"
              sx={{
                border: "1px solid black",
                fontWeight: "bold",
                fontSize: "20px",
                color: "white",
              }}
            >
              Created On
            </TableCell>
            <TableCell
              align="center"
              sx={{
                border: "1px solid black",
                fontWeight: "bold",
                fontSize: "20px",
                color: "white",
              }}
            >
              Updated On
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows
            .filter((row) =>
              row.profile_name
                ?.toLowerCase()
                .includes(searchText?.toLowerCase())
            )
            .map((row) => (
              <TableRow
                hover
                key={row.profile_name}
                className="tblRow"
                as={Link}
                to={`${match.url}/${profile}?profileName=${
                  row.profile_name.includes("&")
                    ? formatProfileName(row.profile_name)
                    : row.profile_name
                }`}
                onClick={() => console.log(row, profile)}
                sx={{ textDecoration: "none" }}
              >
                <TableCell
                  align="center"
                  sx={{ border: 1, fontSize: "15px" }}
                  name="profileName"
                >
                  {row.profile_name}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ border: 1, fontSize: "15px" }}
                  name="profileCreatedOn"
                >
                  {getFormattedDate(row.created_at)}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ border: 1, fontSize: "15px" }}
                  name="profileUpdatedOn"
                >
                  {getFormattedDate(row.modified_at)}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
